<script>
	import { metatags } from "@roxi/routify";
	$: metatags.title = `About | Mustafa Gülsün - Front-end Developer`;

	let sections = [
		{
			id: 1,
			title: "2005-2012",
			content: `
				<p>
				I have been around since Geocities times, building websites for different
				purposes. At the start of my career SEO was the king, so I had to build
				interfaces which are semantic, and meaningful for SE bots. I always
				strived to adhere to W3C standards so that I had an advantage over
				competitors, which later became a basis of my whole career. Late in this 
				period I had a chance to work on Advertiser aspect of the Web. 
				I have been working on Adwords and Facebook Ad campaigns for a client. It was
				interesting to see the client acquisition from a different perspective. What
				people do, where do they hangout, what are their interests, which were
				totally different than my expectations. I think this was the time when I
				started to notice that there was a big gap between what we build and what
				people actually perceive.
				</p>`,
			open: false,
		},
		{
			id: 2,
			title: "2012-2016",
			content: `<p>In this period I have started to work with a publishing company. 
			As a Creative Director, my task was to build their brand identity, web pages,
			and publications with the help of our minimal team. This was a versatile
			and fluid role as we were short of human resources. 
			I was creating their brand identity, designing the magazine, coding their website.
			In my journey here I had a chance to learn print and web Typography in depth.</p>
			`,
			open: false,
		},
		{
			id: 3,
			title: "2016-2019",
			content: `
			<p>
			I started working freelance in this period so I could focus more on
			coding, basically. I was working on many different projects, such as
			building websites for start-ups, or doing performant and pixel perfect
			conversions for clients. Working with their designers through Sketch,
			Figma, and so on, was a part of my daily routine.</p>
			<p>
				In fact, a quote of Minimalism, <q>Less is More</q>, started to translate in me as 
				a <a target="blank" href="https://en.wikipedia.org/wiki/Minimalism_(computing)#See_also">whole approach</a> in this period.
			</p>
			`,
			open: false,
		},
		{
			id: 4,
			title: "2019-Today",
			content: `
			<p>
			I assume I got noticed by Upwork (Inc.) due to my consistent achievements on
			their platform, when they offered me to work with them. I would say my
			last two years are the paramount of my self-development. I had worked in
			different aspects of Web, UI and UX for years, but there has always been a
			knowledge gap for me. Working with them helped me to connect and build all
			my scattered skillset into a totally new career: Front-end Engineering.
			</p>
			`,
			open: false,
		},
	];
</script>

<main id="main">
	<section class="container about">
		<h1>About Me</h1>
		{#each sections as section, i}
			<details>
				<summary class="link-like">
					<h2>{section.title}</h2>
				</summary>
				{@html section.content}
			</details>
		{/each}
	</section>
</main>

<style>
	.about h2 {
		display: inline;
		margin: 0;
	}

	.about summary {
		display: inline-block;
		cursor: pointer;
		color: var(--text-primary);
		position: sticky;
		top: 0;
		background-color: var(--bg-primary);
		border-bottom: 2px solid var(--bg-hover-primary);
		margin-top: 4px;
	}

	.about summary:hover,
	.about summary:focus {
		color: var(--bg-primary);
		background-color: var(--bg-hover-primary);
	}

	.about details > summary::-webkit-details-marker {
		display: none;
	}

	.about details[open] {
		margin-bottom: 3rem;
	}
</style>
